import { render } from "./HeroiconsSolidChip.vue?vue&type=template&id=10d8c133"
const script = {}

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidChip.vue"]])

export default __exports__